module.exports = __webpack_public_path__ + "img/2022-11.e69759dd.jpg";